var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M590 72L590 100",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 590.5,
    cy: 67.3333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M585.987 67.1898C585.987 63.2835 589.288 60.1168 593.358 60.1168C593.943 60.1168 594.511 60.1841 595.056 60.3076C593.742 59.4804 592.187 59 590.519 59C585.814 59 582 62.8056 582 67.5C582 72.1944 585.814 76 590.519 76C592.814 76 594.895 75.0929 596.427 73.6205C595.492 74.0317 594.454 74.2628 593.358 74.2628C589.288 74.2628 585.987 71.0961 585.987 67.1898Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M599.402 66.6003L599.37 64.1461L597.535 65.7189L595.304 65.0564L596.112 67.3367L594.765 69.3813L597.1 69.2179L598.499 71.144L599.133 68.7627L601.345 67.9085L599.402 66.6003Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch6);
export default __webpack_public_path__ + "static/media/church_6.18d6f6f0f03339eed63da670580bbba4.svg";
export { ForwardRef as ReactComponent };